module.exports = __webpack_public_path__ + "assets/img/coast-blitz.c7777de4.png";